import React from "react";
import {TableHeader, TableHeaderCell} from "../CourierStatsWidget.styles";
import {Tooltip} from "antd";

export const PoolIntensitiesTableHeaders = () => {
    return (
        <TableHeader
            style={{
                position: "sticky",
                top: "-12px",
                backgroundColor: "white",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
            }}
        >
            <tr>
                <TableHeaderCell minWidth="100px" maxWidth="120px">
                    <Tooltip title="Havuz Bölgesi">
                        <span>Havuz Bölgesi</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Anlık Havuz Yoğunluk (%)">
                        <span>Anlık Havuz Yoğunluk (%)</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Kuyrukta Bekleyen Sipariş Sayısı">
                        <span>Kuyrukta Bekleyen Sipariş S.</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Slot Seçen Kurye Sayısı">
                        <span>Slot Seçen Kurye S.</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Meşgul Kurye Sayısı">
                        <span>Meşgul Kurye S.</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Aktif Kurye Sayısı">
                        <span>Aktif Kurye S.</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Siparişteki Kurye Sayısı">
                        <span>Siparişteki Kurye S.</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Müsait Kurye Sayısı">
                        <span>Müsait Kurye S.</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Limit">
                        <span>Limit</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Havuz Kurye Sayısı">
                        <span>Havuz Kurye S.</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Slot Seçim (%)">
                        <span>Slot Seçim (%)</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Entegrasyon Tipi">
                        <span>Entegrasyon Tipi</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Aktif Sipariş S.">
                        <span>Aktif Sipariş S.</span>
                    </Tooltip>
                </TableHeaderCell>
                <TableHeaderCell align="center" maxWidth="120px">
                    <Tooltip title="Teslim Edilen Sipariş S.">
                        <span>Teslim Edilen Sipariş S.</span>
                    </Tooltip>
                </TableHeaderCell>
            </tr>
        </TableHeader>
    );
};
